import React from "react";

interface Props {
    dir: number;
    formattedValue: string;
}

const Compass: React.FC<Props> = (props) => {
    const dirTicks: number[] = [];
    for (var i = 0; i < 360; i += 22.5) {
        dirTicks.push(i);
    }

    return (
        <svg viewBox="-100 -100 200 200">
            <circle r="85" cx="0" cy="0" stroke="grey" strokeWidth="10" fill="none"/>
            { dirTicks.map(x => <line x1="0" y1="90" x2="0" y2="80" transform={`rotate(${x})`} stroke="black" strokeWidth="2" />)}
            <text x="0" y="25" textAnchor="middle" fontSize={70}>{props.formattedValue}</text>
            <path d="M0 -65 L-10 -100 L10 -100" fill="blue" stroke="none" transform={`rotate(${props.dir})`} />
        </svg>
    )
};

export default Compass;

